import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import i18n from '@/i18n'
import { DATE_UNITS } from '@/utils/date'

dayjs.extend(relativeTime)

/**
 * @remarks
 * ## FAQ
 *
 * ### Why this didn't make using {@link https://day.js.org/docs/en/customization/relative-time dayjs.updateLocale}?
 * Because it has some issues:
 * - We can't replace only one string (e.g., only for seconds), we have to replace all strings FOR ALL LOCALES.
 * - Even if we replace all strings for all over our locales, it still doesn't work correctly for the `seconds` case.
 *   For example, if we replaced "a few seconds ago" with "just now", it will show "just now ago" instead of "just now".
 *
 * ### Why 44 seconds?
 * Because it is a default {@link https://day.js.org/docs/en/display/from-now threshold} for seconds in dayjs.
 */
export const getTimeAgo = date => {
  const diff = dayjs().diff(dayjs(date), DATE_UNITS.SECOND)

  if (Math.abs(diff) < 44) {
    return i18n.global.t('common.just_now').toLowerCase()
  }

  return dayjs(date).fromNow()
}
